// extracted by mini-css-extract-plugin
module.exports = {"autocite":"autocite__autocite___smEmR","input":"autocite__input___3Za2u"};